const imprintText = [
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>Verantwortlich im Sinne des § 5 TMG:</b>,
  `
  GC Großhandels Contor GmbH
  Altenwall 6
  28195 Bremen

  Telefon: +49 (0)421 2029-0

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>
    <i>Sie haben eine Frage?</i>
  </b>,
  `
  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <i>
    Wenden Sie sich bitte an den
    <a href="http://www.efg-gruppe.de/de/standorte">EFG-Partner</a> in Ihrer Nähe!
  </i>,
  `
  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <i>
    Wo Sie uns finden, sehen Sie
    <a href="http://www.efg-gruppe.de/de/standorte/list">hier</a>.
  </i>,
  `

  E-Mail: `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <i>
    info [at] gc-gruppe.de (bitte Fragen immer erst an den jeweiligen{' '}
    <a href="http://www.efg-gruppe.de/de/standorte">EFG-Partner</a> stellen!)
  </i>,
  `

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>Vertretungsberechtigte Geschäftsführer:</b>,
  `
  Thomas Werner,
  André Wedemeyer,
  Uwe Niederprüm

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>Registergericht:</b>,
  `
  Amtsgericht Bremen

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>Registernummer:</b>,
  `
  HRB 10081


  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>Rechtliche Hinweise</b>,
  `

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>1. Inhalt des Onlineangebotes</b>,
  `

  Der Anbieter übernimmt keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Anbieter, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden sind grundsätzlich ausgeschlossen, sofern seitens des Anbieter kein nachweislich vorsätzliches oder grob fahrlässiges Ver­schulden vorliegt. Alle Angebote sind freibleibend und unverbindlich. Der Anbieter behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte An­kündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>2. Verweise und Links</b>,
  `

  Bei direkten oder indirekten Verweisen auf fremde Internetseiten ("Links"), die außerhalb des Verantwortungsbereiches des Anbieters liegen, würde eine Haftungsverpflichtung aus­schließlich in dem Fall in Kraft treten, in dem der Anbieter von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle rechtswidriger In­halte zu verhindern. Der Anbieter erklärt daher ausdrücklich, dass zum Zeitpunkt der Linksetzung die entsprechenden verlinkten Seiten frei von illegalen Inhalten waren. Der Anbieter hat keinerlei Einfluss auf die aktuelle und zukünftige Gestaltung und auf die Inhal­te der gelinkten/verknüpften Seiten. Deshalb distanziert er sich hiermit ausdrücklich von al­len Inhalten aller gelinkten /verknüpften Seiten, die nach der Linksetzung verändert wur­den. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in vom Anbieter eingerichteten Gästebü­chern, Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder unvollständige In­halte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Drittanbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links auf die jeweilige Veröffentlichung lediglich verweist. Sofern Teile oder einzelne Formulierungen dieses Textes der geltenden Rechtslage nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben die übrigen Teile des Doku­mentes in ihrem Inhalt und ihrer Gültigkeit davon unberührt.

  `,
  // biome-ignore lint/correctness/useJsxKeyInIterable: <explanation>
  <b>3. Urheber- und Kennzeichenrecht</b>,
  `

  Der Anbieter ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafi­ken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Gra­fiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetan­gebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterlie­gen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nen­nung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter ge­schützt sind! Das Copyright für veröffentlichte, vom Anbieter selbst erstellte Objekte bleibt allein beim Anbieter der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung des Anbieters nicht gestattet.`,
];

export default imprintText;
